import fetch from "lib/fetch";
import type { StripeAccount, StripeAccountLink } from "types/stripe";

export const getStripeRedirectionAccountLinkRequest = (accountStripeId: string) =>
    fetch.get<{ data: StripeAccountLink }>(`stripe/redirection/${accountStripeId}`);

export const getStripeAccountInfoRequest = (accountStripeId: string) =>
    fetch.get<{ data: StripeAccount }>(`stripe/accounts/${accountStripeId}`);
